import api from './services.js'
import { baseUrl } from './host.js'
const env = baseUrl.env

const host = baseUrl[env].host
const port = baseUrl[env].port

// 创建诊室
export const addChat = (data) =>
  api({
    url: host + port.event + 'chat/add',
    method: 'post',
    data,
  })

  // 修改诊室名称
export const updateChatName = (params) =>
  api({
    url: host + port.event + 'chat/update',
    method: 'get',
    params,
  })

  // 查询诊室信息
export const getChatInfo = (params) =>
  api({
    url: host + port.event + 'chat/one',
    method: 'get',
    params,
  })

  // 诊室添加人员
export const addPeople = (data) =>
  api({
    url: host + port.event + 'chat/people/add',
    method: 'post',
    data,
  })

  // 诊室删除人员
export const delPeople = (params) =>
  api({
    url: host + port.event + 'chat/people/del',
    method: 'get',
    params,
  })

  // 查看诊室内所有人员
export const getAllPeople = (params) =>
  api({
    url: host + port.event + 'chat/people/all',
    method: 'get',
    params,
  })

  // 查询我的诊室
export const getMyChat = (params) =>
  api({
    url: host + port.event + 'chat/my',
    method: 'get',
    params,
  })

  // 发送消息
export const sendMessage = (data) =>
  api({
    url: host + port.event + 'chat/msg/add',
    method: 'post',
    data,
  })

   // 撤回消息
export const delMessage = (data) =>
  api({
    url: host + port.event + 'chat/msg/del',
    method: 'post',
    data,
  })

  // 查询群消息
export const getMessage = (params) =>
  api({
    url: host + port.event + 'chat/msg/all',
    method: 'get',
    params,
  })

  // 查询用户socket状态
export const getUserSocketStatus = (params) =>
  api({
    url: host + port.event + 'chat/user/soctet/status',
    method: 'get',
    params,
  })

  // 患者查询我的诊室
export const getPatientChat = (params) =>
  api({
    url: host + port.event + 'chat/patient/my',
    method: 'get',
    params,
  })
